import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalConfirm = (props) => {
    return (
        <Modal
            show={props.show}
            onHide={props.handleClose}
            backdrop="static"
            keyboard={false}
            className="adminConfirmModal"
            backdropClassName="adminConfirmModalBackdrop"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.description
                    ? props.description
                    : props.descriptionDelete
                        ? "Если вы продолжите то вернуть его будет невозможно!!!"
                        : "Если вы действительно хотите выйти, то подтвердите это"}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Вернуться обратно
                </Button>
                <Button variant="primary" onClick={props.onClick || props.onConfirm}>
                    Подтвердить
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalConfirm;
